<template>
    <div class="form-container">
        <p v-if="formatedName === 'Stamp Duty'">If you would like to know more about Stamp Duty or the most suitable mortgage rates available for you, please phone us on a local rate at <a href="tel:0330 0945876">0330 0945876</a> or complete the submission form below, and one of our specialist advisers will be in touch.</p>
        <div v-else class="mb-5">If you would like to know the best {{ removeHyphensToUpperCase(calculatorName).replace(' Calculator','') }} rates available for you, please phone us on a local rate at 0330 0945876 or complete the submission form below, and one of our specialist advisers will be in touch.</div>
        <form :id="`form-${ calculatorName }`" @submit="submitForm" @keyup="clearErrorMessages" @change="clearErrorMessages">
            <!-- <div class="row"> -->

                <!-- <pre>{{ calculatorData }}</pre> -->

                <div class="col-md-6 mb-3">
                    <label for="name">Name*</label>
                    <input class="form-control" type="text" id="name" v-model="form.name">

                    <label for="email">Email*</label>
                    <input class="form-control" type="email" id="email" v-model="form.email" >

                    <label for="phone">Telephone*</label>
                    <input class="form-control" type="tel" id="phone" v-model="form.phone" >

                    <label for="postcode">Postcode*</label>
                    <input class="form-control" type="text" id="postcode" v-model="form.postcode" >
                </div>
                <div class="col-md-6 mb-3">
                    <label for="msg">Optional Message</label>
                    <textarea id="msg" rows="10" class="form-control" v-model="form.msg"></textarea>
                </div>
                <div class="col-12 mb-3">
                    <div class="row align-items-center">
                        <div class="col-md-1">
                            <input type="checkbox" id="privacy" v-model="form.consent" >
                        </div>
                        <div class="col-md-11">
                            <label for="privacy">I consent to my personal information being processed in accordance with The Mortgage Centres <a href="/cookies-privacy-statement/" target="_blank">Privacy Policy</a></label>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center mt-3 mb-3"><button type="submit" class="btn calc-btn-secondary">CONTACT US</button></div>
            <!-- </div> -->
        </form>
        <div v-show="showSpinner" class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>

        <div class="form-errors" v-if="formErrors.length > 0">
            <div class="alert alert-danger text-center" role="alert" v-for="(error,i) in formErrors" :key="i">
                {{ error }}
            </div>
        </div>        

        <!-- <div class="alert alert-primary text-center" v-if="submission.submitted === true && submission.is_valid === true" v-html="submission.confirmation_message"></div> -->
        <div class="alert alert-danger text-center" role="alert" v-if="submission.submitted === true && submission.is_valid === false" v-html="validationMessages(submission.validation_messages)"></div>               
    </div>
</template>

<script>
import axios from "axios"
export default {
    props: {
        calculatorName: String,
        calculatorData: Object
    },
    data() {
        return {
			form: {
				name: '',
				email: '',
				phone: '',
                postcode: '',
				msg: '',
				consent: false
			},
			submission: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
            formErrors: [],
            showSpinner: false,
            gfid: 2 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
        }
    },
    methods: {
        removeHyphensToUpperCase(str) {
            return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
        },        
        validationMessages(response) {
            const errorMessage = response;
            console.log(errorMessage)
            if (errorMessage) { return errorMessage["2"] } return
        },
		submitForm(e) {
			e.preventDefault();

            this.showSpinner = true;

			if (!this.form.name) {
				this.formErrors.push("Please enter your name.");
			}
			if (!this.form.email) {
				this.formErrors.push("Please enter your email address.");
			}
			if (!this.form.phone) {
				this.formErrors.push("Please enter your phone number.");
			}
			if (!this.form.postcode) {
				this.formErrors.push("Please enter your postcode.");
			}                        
			if (!this.form.consent) {
				this.formErrors.push("Please agree to our Privacy, Security and Cookie Policy to allow our friendly staff contacting you.");
			}          
            
            //console.log(this.formErrors.length);
           // console.log(this.formErrors);

            if(this.formErrors.length == 0){

                var newSubmission = new FormData();

                newSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
                newSubmission.append("input_1", this.form.name);
                newSubmission.append("input_2", this.form.email);
                newSubmission.append("input_3", this.form.phone);
                newSubmission.append("input_8", this.form.postcode);
                newSubmission.append("input_4", this.form.msg);
                newSubmission.append("input_5", this.calculatorData.calculatorTitle);
                newSubmission.append("input_6.1", this.form.consent ? 'Yes' : 'No');
                newSubmission.append("input_7", this.calculatorData.calculatorResults);

                this.postSubmission(newSubmission);

                // console.log(newSubmission);

            }
		},
        async postSubmission(submissionData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfid + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submission = response;
                // console.log(submission)

                this.showSpinner = false;
                if ( submission.data.is_valid ) {
                    this.resetForm();
                    this.submission.submitted = true;
                    this.submission.is_valid = true;
                    // this.submission.confirmation_message = submission.data.confirmation_message;
                    window.location.href = '/thank-you-calculators';
                }
            } catch(error) {
                // console.log(error)
                this.showSpinner = false;
			}
        },
		resetForm() {
			this.form = {
				name: '',
				email: '',
				phone: '',
				msg: '',
				consent: false
			}
		},
        clearErrorMessages() {
            this.formErrors = []           
        }
    },
    computed: {
        formatedName() {
        let string = this.calculatorName.replace( "calculator", '' ).replace( /-/g, ' ' ).trim()

        const formattedString = (phrase) => {
            return phrase
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        };

        return formattedString( string )
        }
    }
}
</script>

<style lang="scss">
label{
    font-weight: bold;
    font-size: 18px;
}
.spinner {
    margin: 2em auto;
    
    .double-bounce1,
    .double-bounce2 {
        background-color: #FFF;
    }
}
.spinner {
	width: 40px;
	height: 40px;
	position: relative;
}

.double-bounce1,
.double-bounce2 {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-color: white;
	opacity: 0.8;
	position: absolute;
	top: 0;
	left: 0;

	-webkit-animation: sk-bounce 2s infinite ease-in-out;
	animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
	-webkit-animation-delay: -1s;
	animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
	0%,
	100% {
		-webkit-transform: scale(0);
	}
	50% {
		-webkit-transform: scale(1);
	}
}

@keyframes sk-bounce {
	0%,
	100% {
		transform: scale(0);
		-webkit-transform: scale(0);
	}
	50% {
		transform: scale(1);
		-webkit-transform: scale(1);
	}
}
</style>